import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_URL}`;

// Fetch BDE employees by branch
export const fetchBdeEmployees = async (branch) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/bde-employees`, {
      params: { branch }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching BDE employees:', error);
    throw error;
  }
};

// Fetch all courses
export const fetchCourses = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/course`);
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error);
    throw error;
  }
};

// Submit student data
export const submitStudentData = async (studentData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/student`, studentData, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    console.error('Error submitting student data:', error);
    throw error;
  }
};

const api = {
    fetchBdeEmployees,
    fetchCourses,
    submitStudentData
  };
  
  export default api;